// utils/analytics.js

import { v4 as uuidv4 } from 'uuid';

/**
 * Calculate scroll depth as a percentage (0–100)
 */
export const getScrollDepth = () => {
  const scrolled = window.scrollY + window.innerHeight;
  const total = document.documentElement.scrollHeight;
  return Math.min(100, Math.round((scrolled / total) * 100));
};

/**
 * Retrieve or generate a session ID stored in sessionStorage
 */
export const getSessionId = () => {
  let sessionId = sessionStorage.getItem("session_id");
  if (!sessionId) {
    sessionId = uuidv4(); // Securely generate a UUID v4
    sessionStorage.setItem("session_id", sessionId);
  }
  return sessionId;
};

/**
 * Return user agent string
 */
export const getUserAgent = () => navigator.userAgent;

/**
 * Generate a unique key for tracking time per page, per day
 * @param {string} pageUrl - The current page URL
 */
export const getDateKey = (pageUrl) => {
  const today = new Date().toISOString().split("T")[0]; // e.g., "2025-04-06"
  return `${pageUrl}-${today}`;
};
